import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c47de5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loader" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "content-container"
}
const _hoisted_5 = { class: "top-content" }
const _hoisted_6 = { class: "form-container" }
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = {
  key: 0,
  style: {"padding-top":"1rem"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "VAT Loans:")
], -1))

import { computed, onMounted, ref } from "vue";
import { DrawdownTableItem } from "@/models/Drawdown";
import { DrawdownHelper } from "@/services/helpers/DrawdownHelper";
import TablePersistentChecking, { ITableExpose } from "@/components/TablePersistentChecking.vue";
import { VatLoan } from "@/models/VatLoan";
import MarketSelector from "@/components/MarketSelector.vue";
import DatePeriod from "@/types/DatePeriod";
import { marketSelection } from "@/services/helpers/Helper";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmedDrawdown',
  setup(__props) {

const infoError = ref();
const isLoading = ref(false);
const isLoan = ref<boolean>(false);
const isConfirmed = ref<boolean>(true);
const table = ref<ITableExpose<DrawdownTableItem>>();
const rows = ref<DrawdownTableItem[]>([]);
const rowCount = ref(50);
const cols = computed(() => getCols(!isLoan.value));
const colsLoans = computed(() => getLoanCols());
const RowsLoans = ref<VatLoan[]>([]);
const urlParams = process.env.VUE_APP_GET_CONFIRMED_DRAWDOWNS_URL_PARAMS;
const checkedRow = ref<DrawdownTableItem>();
const DrawdownServices: DrawdownHelper = new DrawdownHelper();

onMounted(async () => {
    checkedRow.value = undefined;
    getConfirmedDrawdowns(urlParams!, marketSelection.value);
});
async function getConfirmedDrawdowns(urlParams: string, market: string) {
    try {
        const data = await DrawdownServices.getConfirmedDrawdowns(urlParams, market);
        rows.value = data
            .map((x) => new DrawdownTableItem(x))
            .filter((x) => x.Market === marketSelection.value);

        if (isConfirmed.value === true) {
            rows.value.forEach((obj) => {
                const sum = obj.VatLoans.reduce(
                    (total, loan) => total + parseFloat(loan.VatLoanAmount),
                    0
                );
                obj.SumVatLoans = parseFloat(sum.toFixed(2));
            });
        }
    } catch (error) {
        infoError.value = error;
        useNotifierWithErrFormatter().error({ name: "", errorType: "Geting Confirmed Drawdowns", error });
    } finally {
        isLoading.value = false;
    }
}
function updateCheckedRows() {
    checkedRow.value = table.value?.GetChecked()[0];
    if (checkedRow.value) {
        getLoans(checkedRow.value);
    }
}
function updateMarketSelection() {
    checkedRow.value = undefined;
    getConfirmedDrawdowns(urlParams!, marketSelection.value);
}
async function getLoans(checkedRow: DrawdownTableItem) {
    RowsLoans.value = [];
    for (const i of checkedRow.VatLoans) {
        let loan: VatLoan = {
            VatLoanAmount: parseFloat(i.VatLoanAmount),
            VatLoanPeriod: new DatePeriod(i.VatLoanPeriod),
            UserEmail: i.UserEmail,
        };
        RowsLoans.value.push(loan);
    }
}
function getCols(confirmed?: boolean): Array<keyof DrawdownTableItem> {
    const baseColumns: Array<keyof DrawdownTableItem> = [
        "Market",
        "DrawdownDate",
        "DrawdownAmount",
    ];
    if (confirmed) {
        return [...baseColumns, "SumVatLoans", "UserEmail"];
    } else {
        return [...baseColumns, "UserEmail"];
    }
}
function getLoanCols(includeBalance?: boolean): Array<keyof VatLoan> {
    const baseLoanColumns: Array<keyof VatLoan> = [
        "VatLoanAmount",
        "VatLoanPeriod",
        "UserEmail"
    ];
    if (includeBalance) {
        return [...baseLoanColumns, "RemainingBalance"];
    }
    return baseLoanColumns;
}

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createVNode(MarketSelector, { onChange: updateMarketSelection })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TablePersistentChecking, {
            ref_key: "table",
            ref: table,
            Rows: rows.value,
            Cols: cols.value,
            HideTable: false,
            HasError: !!infoError.value,
            HasCheckBox: true,
            SingleSelection: true,
            CheckCallBack: updateCheckedRows,
            RowsPerPage: rowCount.value,
            "onUpdate:RowsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((rowCount).value = $event)),
            SplitColKeys: ""
          }, null, 8, ["Rows", "Cols", "HasError", "RowsPerPage"]),
          (checkedRow.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(TablePersistentChecking, {
                  Rows: RowsLoans.value,
                  Cols: colsLoans.value,
                  SplitColKeys: ""
                }, null, 8, ["Rows", "Cols"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
}
}

})